enum OrderSkuQuantity {
    /** 单款单件 */
    SINGLE_SKU_SINGLE_PIECE = "SINGLE_SKU_SINGLE_PIECE",
    /** 单款多件 */
    SINGLE_SKU_MULTI_PIECE = "SINGLE_SKU_MULTI_PIECE",
    /** 多款多件 */
    MULTI_SKU = "MULTI_SKU",
    /** 无商品 */
    EMPTY_SKU = "EMPTY_SKU",
}

export default OrderSkuQuantity;
